
import * as React from "react";

interface INotFoundProps {}

const Unauthorized: React.FunctionComponent<INotFoundProps> = (props) => {
  return (
    <div className="unauthorized-label-container">
    <h2 className="unauthorized-label-heading">Access Denied Due to Permissions</h2>
    <p className="unauthorized-label-message">
      You are currently unable to access this application because a user role has not been assigned to you.
      For access, please contact one of the following: your supervisor, your Area's Regional Data Administrator,
      your Wildfire Management Branch contact, or Wildfire Applications Support via
      <a className="unauthorized-label-link" href="mailto:wildfire.applications@gov.ab.ca"> wildfire.applications@gov.ab.ca</a> or +1 780-427-8100.
    </p>
  </div>
  );
};

export default Unauthorized;
